module.exports = __webpack_public_path__ + "a87a23664c9d4c7cfecb0f72742aa69a.pdf";